import { Col, Row } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { DARK_KUBBE, BACKGROUND_KUBBE } from "../../constants/Colors";
import Footer from "../../assets/img/Footer.png";
import Flowers from "../../assets/img/feature2.png";
import Truck from "../../assets/img/feature1.png";
import NavBarRoot from "../../components/molecules/NavBarRoot/NavBarRoot";

const FooterWrapper = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  background-color: ${DARK_KUBBE};
  padding: 20px 0px;
  display: flex;
  img {
    height: clamp(20px, 5vw, 50px);
    object-fit: cover;
    margin: auto;
  }
  @media (max-width: 991px) {
    width: 100%;
    margin-left: 0px;
  }
`;

const TextContent = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  align-content: center;
  text-align: center;
  h1 {
    font-size: clamp(1rem, 2.5vw, 40px);
    font-family: "Raleway";
    font-weight: 500;
    margin: 0;
    color: #fff;
    @media (max-width: 768px) {
      font-size: clamp(1rem, 5.5vw, 40px);
    }
  }
  h1 strong {
    font-weight: 700;
  }
`;

const CardDetailStyled = styled.div`
  position: relative;
  background-color: transparent;
  max-width: 730px;
  width: 100%;
  border-radius: 30px;
  @media (max-width: 991px) {
    width: 100%;
  }
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.08);
  img {
    width: 100%;
    height: auto;
    background-color: transparent;
    border-radius: 40px;
    @media (max-width: 991px) {
      border-radius: 30px;
    }
    box-shadow: 10px 10px 20px ${DARK_KUBBE}80;
  }
`;

const DivBackground = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: ${BACKGROUND_KUBBE};
  background-repeat: no-repeat !important;
  background-size: cover !important;
  padding: 0 30px;

  @media (max-width: 991px) {
    padding: 0 10px;
  }
`;
const WhichUser = () => {
  const history = useHistory();

  return (
    <>
      <DivBackground>
        <header>
          <NavBarRoot />
        </header>
        <main
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-evenly",
          }}
        >
          <Row>
            <Col md="12">
              <h2 className="h2 text-center font-weight-bold">¡COMENCEMOS! </h2>
            </Col>
          </Row>

          <Row className="py-4">
            <Col md={6} className="d-flex justify-content-center">
              <CardDetailStyled
                className="cursor-pointer"
                onClick={() =>
                  history.push({
                    pathname: "/register",
                    search: "?type=carriers",
                  })
                }
              >
                <TextContent>
                  <h1>
                    Registrate como
                    <br />
                    <strong>TOMADOR DE CARGA</strong>
                  </h1>
                </TextContent>
                <img src={Truck} alt="Imagen de transportista" />
              </CardDetailStyled>
            </Col>
            <Col md={6} className="d-flex justify-content-center mt-4 mt-md-0">
              <CardDetailStyled
                onClick={() =>
                  history.push({
                    pathname: "/register",
                    search: "?type=Loadgiver",
                  })
                }
              >
                <TextContent>
                  <h1>
                    Registrate como
                    <br />
                    <strong>DADOR DE CARGA</strong>
                  </h1>
                </TextContent>
                <img src={Flowers} alt="Imagen de dador de carga" />
              </CardDetailStyled>
            </Col>
          </Row>
        </main>
        <footer>
          <FooterWrapper>
            <img src={Footer} alt="footer" />
          </FooterWrapper>
        </footer>
      </DivBackground>
    </>
  );
};

export default WhichUser;
